// Generated from ContestScore's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestScoreCollectionFilterGroups
  = | {
    readonly contest: Iri
    readonly participantCategory?: Iri | Iri[]
  }

export const contestScoreCollectionFilterMapping: FilterDefinitionMapping<ContestScoreCollectionFilterGroups> = {
  contest: 'contest',
  participantCategory: 'participant.category',
}

export type ContestScoreCollectionSort = never
